export default __webpack_public_path__ + "8a30117f4b67d0c18105c25d86e75b6d.svg";